function updateProgressBars() {
  document.querySelectorAll(".product-progress-bar-container .progress-bar").forEach((bar) => {
    const value = parseInt(bar.dataset.value)
    const fill = bar.querySelector(".progress-bar__fill")
    const max = parseInt(bar.getAttribute("aria-valuemax")) || 5

    if (!fill) return;

    fill.style.width = (value / max) * 100 + "%"

    const segments = bar.querySelectorAll(".progress-bar__segment")
    const barWidth = bar.offsetWidth
    segments.forEach((segment, idx) => {
      const leftPosition = ((idx + 1) / max) * barWidth
      segment.style.left = `${leftPosition}px`
    })
  })
}

document.addEventListener("DOMContentLoaded", updateProgressBars)
window.addEventListener("resize", updateProgressBars)
